import axios from 'axios';

const CONTROLLER_PATH = 'Invoice';

class InvoiceService {
    getlist(customerCompanyId) {
        return axios.get(CONTROLLER_PATH + `/getlist?customerCompanyId=${customerCompanyId}`).then((response) => response.data);
    }

    create(customerCompanyId, invoiceDate, dueDate) {
        try {
            return axios.get(CONTROLLER_PATH + `/?customerCompanyId=${customerCompanyId}&invoiceDate=${invoiceDate}&dueDate=${dueDate}`).then((response) => response.data);
        } catch (e) {
            return e;
        }
    }

    delete(invoiceId) {
        return axios.delete(CONTROLLER_PATH + `/${invoiceId}`);
    }
}

export default new InvoiceService();
